import { createSelector } from 'reselect'

export const getRegistrationPriceFormData = createSelector(
  state => (state && state.checkRegistrationCost && state.checkRegistrationCost.formData ? state.checkRegistrationCost.formData : null),
  formData => formData
)
